var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_604_1216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.31 142.27C67.015 132.475 61.645 118.015 61.285 101.77V98.23C61.645 81.985 67.015 67.525 75.31 57.73C86.08 43.765 102.07 34.9 119.92 34.9C130.9 34.9 141.19 38.26 149.98 44.095C136.78 32.275 119.38 25.075 100.285 25H100C58.585 25 25 58.585 25 100C25 140.23 56.665 173.05 96.43 174.91C97.615 174.97 98.8 175 100 175C119.2 175 136.72 167.785 149.98 155.92C141.19 161.74 130.915 165.1 119.92 165.1C102.07 165.1 86.08 156.235 75.31 142.27Z",
    fill: "url(#paint0_linear_604_1216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3101 57.7299C82.1951 49.5999 91.0751 44.7099 100.795 44.7099C122.635 44.7099 140.32 69.4599 140.32 99.9999C140.32 130.54 122.62 155.29 100.795 155.29C91.0901 155.29 82.1951 150.385 75.3101 142.27C86.0801 156.235 102.07 165.1 119.92 165.1C130.9 165.1 141.19 161.74 149.98 155.92C165.34 142.18 175 122.215 175 99.9999C175 77.7849 165.34 57.8199 149.98 44.0949C141.19 38.2599 130.915 34.8999 119.92 34.8999C102.07 34.8999 86.0801 43.7649 75.3101 57.7299Z",
    fill: "url(#paint1_linear_604_1216)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_604_1216",
    x1: 87.4934,
    y1: 27.4456,
    x2: 87.4934,
    y2: 172.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_604_1216",
    x1: 125.156,
    y1: 36.0138,
    x2: 125.156,
    y2: 164.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_604_1216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.cc5da9ccc0239b0dc8a94d00a37fe647.svg";
export { ForwardRef as ReactComponent };